import { apiPost } from '.';
import {
  UserActionRecordFilters,
  UserActionsMixedResponse,
} from '@go-shared/types/userActionRecord';

export const getFilteredActions = async (filters: UserActionRecordFilters) => {
  return apiPost<UserActionsMixedResponse>('/user-actions-records/filtered', filters);
};
